<div class="side-menu-call-to-action">
    <div class="side-menu-call-to-action__indicator"></div>
    <div class="side-menu-call-to-action__label">
        {{ label }}
    </div>
    <nw-icon class="side-menu-call-to-action__chevron"
        ><svg
            xmlns="http://www.w3.org/2000/svg"
            fill
            viewBox="0 0 13 22"
            height="100%"
            width="100%"
            style="display: block"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
        >
            <path
                fill="currentColor"
                d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
            />
        </svg>
    </nw-icon>
</div>
